import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const addProductToCartFromCheckout = createAppAsyncThunk(
  'checkout/addProductToCartFromCheckout',
  async (
    { partnumber, quantity, _showLoadingOnButtons = true }: {partnumber: string, quantity: string, _showLoadingOnButtons?: boolean},
    {
      getState,
      rejectWithValue,
      extra: { checkoutService }
    }) => {
    const storeId = getState().root.storeConf.storeId;
    const payload = { partnumber, quantity };
    try {
      return await checkoutService.addProductToCartFromCheckout({ ...payload, storeId });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
